module.exports = __webpack_public_path__ + "img/04.881d0799.jpg";